import { Tooltip } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteWantedProps } from './DeleteWanted.types';
import * as Styled from './DeleteWanted.styles';

export const DeleteWanted = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  owner,
}: DeleteWantedProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.POSZUKIWANY]?.edit;

  return (
    <>
      <Tooltip
        placement="bottom-start"
        disableHoverListener={!isPermsDisabled}
        title={formatMessage({ id: AppMessages['common.noPermissions'] })}
      >
        <Styled.TrashIcon
          onClick={isPermsDisabled ? undefined : onModalOpen}
          tabIndex={isPermsDisabled ? -1 : 0}
          disabled={isPermsDisabled}
        />
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['wanted.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['wanted.delete.subtitle'] }, { name: `${owner.nazwisko} ${owner.imie}` })}
        </ActionModal.Subtitle>
        <ActionModal.Text>{formatMessage({ id: AppMessages['wanted.delete.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
